import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import AdditionalInfo from './AdditionalInfo';

class ProductSpecifications extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stdImage: null,
			mtcImage: null,
			label: this.props.specifications.imageLinks.length > 0 ?
				this.props.specifications.imageLinks[0].title : null
		};
	}

	handleChangeImage(title, stdImage, mtcImage) {
		this.setState({
			label: title,
			stdImage,
			mtcImage
		});
		global.dataLayer.push({
			event: 'Product Specifications',
			eventCategory: 'Product Specifications',
			eventAction: 'item clicked',
			eventLabel: title
		});
	}

	render() {
		const additionalInfo = this.props.specifications.additional.map(
			(additional,index) => <AdditionalInfo
										key={ index }
										additional={ additional }
										standard={ this.props.standard }
									/>
		);

		let stack;
		if (this.state.label &&
			this.state.label.toLowerCase() === 'capacity' &&
			this.props.specifications.stackOfStuff) {
			stack = (
				<img
					className="stack"
					src={ this.props.specifications.stackOfStuff }
					alt="Stack"
				/>
			);
		}

		let imageSource;
		if (this.props.specifications.imageLinks.length > 0) {
			if (this.state.stdImage === null && this.state.mtcImage === null) {
				imageSource = this.props.standard ?
					this.props.specifications.imageLinks[0].stdImage
					: this.props.specifications.imageLinks[0].mtcImage;
			} else {
				imageSource = this.props.standard ?
					this.state.stdImage : this.state.mtcImage;
			}
		}

		let imageLinks;
		// when only one entry and it's capacity
		if (this.props.specifications.imageLinks.length > 1) {
			imageLinks = this.props.specifications.imageLinks.map(image => {
				let html;
				if (image.stdImage !== null && image.mtcImage !== null) {
					html = (
						<li
							key={ image.title }
							onClick={
								() => this.handleChangeImage(
									image.title,
									image.stdImage,
									image.mtcImage
								)
							}
							className={ image.title === this.state.label ? 'active' : '' }
						>
							{ image.title }
						</li>
					);
				}
				return html;
			});
		}

		return (
			<section className="specifications" id="specifications">
				<h2 className="title">Specifications</h2>
				<div className="row spec-demensions">
					<div className="col sm-3 options">
						<ul>
							{ imageLinks }
						</ul>
					</div>
					<div className="col sm-8 spec-image">
						<img src={ imageSource } alt="" />
						{ stack }
					</div>
				</div>
				<div className="row additional-info">
					<ul>
						{ additionalInfo }
					</ul>
				</div>
				<div className="footnote row">
					<div className="col">
						<span className="uppercase">Note:</span> All dimensions and weights
						provided are approximate, and are subject to change without notice.
					</div>
				</div>
			</section>
		);
	}
}

export default branch({
	specifications: ['product', 'specifications']
}, ProductSpecifications);


// WEBPACK FOOTER //
// ./src/pages/product/ProductSpecifications.js